export const HELP_URL =
  'https://ayuda.crehana.com/es/collections/3387926-educacion#crehana-para-empresas';
